import type { ReactNode } from 'react'

import { GUIA_LABELS } from '@utils/guiaLabels.js'

export type PassoTabId = 'agir' | 'registrar'

export interface PassoTab {
  id: PassoTabId
  label: string
  panel: ReactNode
}

interface Props {
  tabs: PassoTab[]
  active: PassoTabId
  onChange: (id: PassoTabId) => void
}

export function PassoTabs({ tabs, active, onChange }: Props) {
  const activeTab = tabs.find((t) => t.id === active) ?? tabs[0]
  if (!activeTab) return null

  return (
    <div className='cf3-passo-tabs cf3-passo-tabs--segment'>
      <div
        className='cf3-segment cf3-segment--full'
        role='tablist'
        aria-label={GUIA_LABELS.secoesDaEtapa}
      >
        {tabs.map((tab) => {
          const isActive = tab.id === active
          return (
            <button
              key={tab.id}
              type='button'
              role='tab'
              id={`passo-tab-${tab.id}`}
              aria-selected={isActive}
              aria-controls={`passo-panel-${tab.id}`}
              className={['cf3-segment__btn', isActive ? 'cf3-segment__btn--active' : '']
                .filter(Boolean)
                .join(' ')}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          )
        })}
      </div>

      <div
        id={`passo-panel-${activeTab.id}`}
        role='tabpanel'
        aria-labelledby={`passo-tab-${activeTab.id}`}
        className='cf3-passo-tabs__panel'
        tabIndex={0}
      >
        {activeTab.panel}
      </div>
    </div>
  )
}
